module.exports = __webpack_public_path__ + "media/post-listing-cta-background@2x.de2cd48b.jpg";